module.exports = __webpack_public_path__ + "img/checked.f241ef89.png";